import { useState, useEffect } from "react";
import { getAllPosts } from "../api/post.api";
import MovieCard from "../components/MovieCard";
import bgImage from "../assets/posts-bg.png";
import ReelLoader from "../components/LoadingReel";

const Post = () => {
  const [allPosts, setAllPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const posts = await getAllPosts();
        setAllPosts(posts);
      } catch (error) {
        console.log("Error front end: " + error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const showLoader = isLoading || !imageLoaded;

  return (
    <>
      {showLoader && <ReelLoader />}

      <div className={`post-content ${showLoader ? "hide" : "show"}`}>
        <div className="post-hero-container">
          <div className="post-hero-media">
            <img
              src={bgImage}
              style={{ width: "100%" }}
              alt=""
              onLoad={() => setImageLoaded(true)}
            />
          </div>

          <div className="post-hero-text">
            <div className="post-hero-title">
              <h1 className="post-hero-felice">FELICE</h1>
              <h1 className="post-hero-cinema">POSTS</h1>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 20 }}>
          <div className="review-cards-list-container">
            {allPosts.map((post) => (
              <MovieCard
                key={post.pid}
                id={post.pid}
                poster={post.movie.poster}
                redirectLink={`/posts/${post.pid}`}
                disabledLink={false}
                description={post.type}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Post;
